import React, { useState } from "react";
//#region types
import { WintFormExpandableSectionProps } from "models/propTypes/wintFormPropsTypes";
//#endregion
//#region components
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Grid, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const ExpandableSection: React.FC<WintFormExpandableSectionProps> = (props) => {
  const { children, initiallyOpen, alwaysOpen, summary, hasErrors, submitCount, isSubmitting, className, onToggle } =
    props;

  const [expanded, setExpanded] = useState<boolean>(initiallyOpen ?? false);

  React.useEffect(() => {
    if (submitCount && !isSubmitting && hasErrors) setExpanded(true);
  }, [submitCount, isSubmitting]);

  React.useEffect(() => {
    if (initiallyOpen || alwaysOpen) setExpanded(true);
  }, [initiallyOpen]);

  return (
    <Grid
      container
      direction={"column"}
      className={clsx(cssExports.expandableForm, cssExports.wintFormExpandableForm, className)}
    >
      <Accordion
        className={cssExports.expansionPanel}
        disableGutters
        expanded={expanded}
        classes={{
          expanded: cssExports.expandedStep,
        }}
      >
        {summary && (
          <AccordionSummary
            classes={{
              root: cssExports.expansionPanelSummary,
              content: cssExports.expansionPanelSummaryContent,
              expandIconWrapper: cssExports.expansionPanelIcon,
              expanded: cssExports.expansionPanelExpandedSummary,
            }}
            onClick={() => {
              if (alwaysOpen) return;
              setExpanded(!expanded);
              onToggle?.(!expanded);
            }}
            expandIcon={!alwaysOpen && <ExpandMoreIcon />}
          >
            {summary}
          </AccordionSummary>
        )}
        <AccordionDetails
          classes={{
            root: cssExports.expansionPanelDetails,
          }}
        >
          <Grid container marginTop={1.5}>
            {children}
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
};

export default ExpandableSection;
